//* 组件库
import { $loading } from "various-ui";

export const useComposable = () => {
    //* 插件
    const i18n = useI18n();

    //* 静态变量
    const vars = {
        species: [
            { label: i18n.t("Human", 2), value: "9606" },
            { label: i18n.t("Mouse", 2), value: "10090" },
            { label: i18n.t("Rat", 2), value: "10116" },
        ],
    };

    //* 响应式变量
    const refs = {
        mode: ref<string>("ncbi"),
    };

    //* 表单数据
    const data = reactive({ id: "", species: "9606", protein: "", transcript: "" });
    //* 转换结果
    const result = reactive({ id: "", mode: "", species: "", protein: "", transcript: "" });

    //* 函数列表
    const methods = {
        submit: () => {
            $loading.open({ message: i18n.t("UnderLoad") });
            api.frontend("/api/bio/transform-id", {
                data: Object.assign(data, { mode: refs.mode.value }),
                method: "POST",
                finally: () => $loading.close(),
                success: (response) => {
                    result.id = response?.id || "No corresponding data.";
                    result.mode = response?.mode || "";
                    result.species = response?.species || "";
                    result.protein = response?.protein || "No corresponding data.";
                    result.transcript = response?.transcript || "No corresponding data.";
                },
            });
        },
    };

    //* 计算属性
    const computeds = {
        name: computed(() => {
            if (!result.mode) return i18n.t("ConversionResults");
            else {
                if (result.mode == "ensembl") return "Ensembl";
                else {
                    return "NCBI";
                }
            }
        }),

        disabled: computed(() => {
            return !data.id && !data.protein && !data.transcript;
        }),
    };

    return { vars, refs, data, result, methods, computeds };
};
